import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import requireAuth from '../../components/hocs/requireAuth';
import { paymentIconsDictionary } from '../../utils/constants';
import Img from '../../components/Img';

class InvoicePrintPage extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        if (!this.props.subscribe.selectedInvoice) {
            this.props.history.push(`/subscriptions`);
            return null;
        }
        const { planName, date, amount } = this.props.subscribe.selectedInvoice;
        const { last4, type } = this.props.subscribe.selectedInvoice.paymentSource || {};
        const { user } = this.props.auth;
        const dots = type === 'American Express' ? '**** ****** *' : '**** **** **** ';
        return (
            <div>
                <React.Fragment>
                    <div className={`bg-transparent main-content print mt32`}>
                        <div className={`container bg-transparent`}>
                            <div className="row">
                                <div className="col mb8">
                                    <div>
                                        <Img src="/img/utr-oracle-logo-header--dark.svg" width="150" />
                                    </div>
                                </div>
                                <h6 className="d-flex align-items-center justify-flex-end">
                                    <u className="clickable text-body text-small text-normal" onClick={() => this.props.history.push(`/subscriptions`)}>Back to billing</u>
                                </h6>
                            </div>
                            <div>
                                <div>
                                    <h4>UTR Sports - Service Invoice</h4>
                                </div>
                                <span>Customer Email: {user.email}</span>
                                <hr />
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Description</th>
                                            <th>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{moment(date).format('MMMM D, YYYY')}</td>
                                            <td>{planName}</td>
                                            <td>${amount}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                {this.props.subscribe.selectedInvoice.paymentSource && (
                                    <div>
                                        <strong>Payment Method:</strong>
                                        <Img className="payment-icon" style={{ width: '64' }} src={`/img/payment/${paymentIconsDictionary[type?.toLowerCase()]}`} />
                                        <span>{`${dots}${last4}`}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            </div>
        );
    }
}

function mapDispatchToProps() {
    return {};
}

function mapStateToProps({ subscribe, auth }) {
    return { subscribe, auth };
}

const component = requireAuth(connect(mapStateToProps, mapDispatchToProps)(InvoicePrintPage));

export default {
    component,
};
